// extracted by mini-css-extract-plugin
export default {"neon":"EJLe0gCs","borders":"SwpOJBY0","content":"RVwifYVB"};